/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_CtaInputs */

const en_visa_l1_cta = /** @type {(inputs: Visa_L1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan your L visa transfer`)
};

const pt_visa_l1_cta = /** @type {(inputs: Visa_L1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planeje sua transferência de visto L`)
};

const es_visa_l1_cta = /** @type {(inputs: Visa_L1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planifique su transferencia de visa L`)
};

/**
* | output |
* | --- |
* | "Plan your L visa transfer" |
*
* @param {Visa_L1_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_cta = /** @type {((inputs?: Visa_L1_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_cta(inputs)
	if (locale === "es") return es_visa_l1_cta(inputs)
	return en_visa_l1_cta(inputs)
});